export class HowWeWork {
  constructor() {
    const header = document.querySelector('._how-we-work-header');
    const controls = document.querySelector('._how-we-work-controls');
    const items = document.querySelectorAll('._how-we-work-controls .item');
    const steps = document.querySelectorAll('._how-we-work-step');
    const boxes = document.querySelectorAll('._how-we-work-box');

    function controlsFloating(wpadminbar) {
      let contentHeight = 0;

      steps.forEach(step => (contentHeight += step.offsetHeight));
      boxes.forEach(box => (contentHeight += box.offsetHeight));

      if (
        window.innerWidth >= 992 &&
        (window.scrollY >= header.offsetHeight) &&
        (window.scrollY < header.offsetHeight + contentHeight + (wpadminbar ? 32 : 0))
      ) {
        controls.style.position = 'fixed';
        controls.style.top = (wpadminbar ? 112 : 80) + 'px';
        controls.style.left = '15px';
        steps[0].style.marginTop = controls.offsetHeight + 'px';    
      } else if (
        window.innerWidth >= 992 &&
        (window.scrollY >= header.offsetHeight + contentHeight + (wpadminbar ? 32 : 0))
      ) {
        controls.style.position = 'absolute';
        controls.style.top = header.offsetHeight + contentHeight + (wpadminbar ? 32 : 0) + 'px';
        controls.style.left = null;
        steps[0].style.marginTop = controls.offsetHeight + 'px';
      } else {
        controls.style.position = null;
        controls.style.top = null;
        controls.style.left = null;
        steps[0].style.marginTop = null;
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      const wpadminbar = document.querySelector('#wpadminbar');

      if ( controls ) {
        window.addEventListener('scroll', () => controlsFloating(wpadminbar));
        window.addEventListener('resize', () => controlsFloating(wpadminbar));
      }

      controls?.querySelectorAll('.gradation-btn').forEach(element => {
        element.addEventListener('click', e => {
          e.preventDefault();

          const target = document.querySelector(e.target.getAttribute('href'));

          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - (wpadminbar ? 192 : 160),
            behavior: 'smooth',
          });
        });
      });
    });

    const intersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          items.forEach((item, itemID) => {
            if (itemID + 1 == +entry.target.id.slice(-1)) {
              item.classList.add('active');
            } else {
              item.classList.remove('active');
            }
          });
        }
      });
    }, {
      threshold: 0.5
    });

    steps?.forEach(step => intersectionObserver.observe(step));

    const slides = document.querySelectorAll('._how-we-work-box--1 .swiper-slide-inner');
    const textSection = document.querySelector('._how-we-work-box--1 .text');
    const tagsSection = document.querySelector('._how-we-work-box--1 .tags');

    slides?.forEach((slide, slideID) => {
      const textClone = textSection.cloneNode(true);
      const tagsClone = tagsSection.cloneNode(true);

      textClone.id = 'text-clone-' + slideID;
      tagsClone.id = 'tags-clone-' + slideID;

      const tags = tagsClone.querySelectorAll('li');

      tags.forEach(tag => {
        if (tag.dataset.swiperSlideIndex.includes(slideID)) {
          tag.classList.add('active');
        } else {
          tag.classList.remove('active');
        }
      });

      slide.appendChild(textClone);
      slide.appendChild(tagsClone);
    });
  }
}

export default new HowWeWork;
